export default "__VITE_ASSET__Bfwsbhc9__"